import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.css'],
})
export class RemarksComponent implements OnInit {
  datas;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RemarksComponent>
  ) {
    this.datas = data;
  }

  ngOnInit(): void {}
  cancelReason() {
    this.dialogRef.close();
  }
}
